module.exports = __webpack_public_path__ + "static/18-08b92a02ba5dc6ec7e7ddd3e4fd02bce.jpg";